(function() {
  const originalFetch = window.fetch;

  window.fetch = function(...args) {
    const url = args[0];

    if (
      typeof url === 'string' &&
      (url.includes('/cart/add') || url.includes('/cart/add.js'))
    ) {
      alert('Purchasing is temporarily unavailable.');
      return Promise.reject(new Error('Cart disabled'));
    }

    return originalFetch.apply(this, args);
  };
})();


(function() {

  // Clear cart immediately
  fetch('/cart/clear.js', {
    method: 'POST'
  }).catch(() => {});

  // Prevent visiting cart
  if (
    window.location.pathname === '/cart' ||
    window.location.pathname.includes('/checkout')
  ) {
    window.location.replace('/');
  }

})();